import { api, getList } from "./api";
import type { ChambreFroide, ChambreFroidePayload } from "../types/chambrefroide";
import type { HistoriqueArretChambreFroide } from "../types/historiquearretchambre";

// Récupérer toutes les chambres froides
export async function getAllChambresFroides(): Promise<ChambreFroide[]> {
  return getList<ChambreFroide>("/chambres-froides/");
}

// Créer une chambre froide
export async function createChambreFroide(payload: ChambreFroidePayload): Promise<ChambreFroide> {
  const res = await api.post("/chambres-froides/", payload);
  return res.data;
}

// Mettre à jour une chambre froide
export async function updateChambreFroide(id: string, payload: ChambreFroidePayload): Promise<ChambreFroide> {
  const res = await api.put(`/chambres-froides/${id}/`, payload);
  return res.data;
}

// Supprimer une chambre froide
export async function deleteChambreFroide(id: string): Promise<void> {
  await api.delete(`/chambres-froides/${id}/`);
}

// ✅ Récupérer l’historique des arrêts pour une chambre froide
export async function getHistoriqueChambreFroide(chambreId: string): Promise<HistoriqueArretChambreFroide[]> {
  return getList<HistoriqueArretChambreFroide>(`/chambres-froides/${chambreId}/historiques/`);
}
